module.exports = __webpack_public_path__ + "img/图1-5  国家标准中规定的标题栏.b1cab3aa.jpg";